import {
  Card,
  Flex,
  Skeleton,
  SkeletonBodyText,
  SkeletonBox,
  SkeletonHeading,
} from '@utilitywarehouse/hearth-react';

const SimTileSkeleton = () => (
  <Skeleton loadingTitle="SIM tile loading">
    <Card
      data-testid="mobile-sim-skeleton"
      spacing="lg"
      direction="column"
      alignItems="stretch"
    >
      <SkeletonHeading size="lg" />
      <Flex gap="100" alignItems="baseline" wrap="wrap">
        <SkeletonBox
          height="30px"
          width="120px"
          borderRadius="sm"
          className="simTile__price"
          display="inline-block"
        />
      </Flex>

      <Flex direction="column" spacing="md">
        <SkeletonBodyText width="60%" />
        <SkeletonBodyText width="60%" />
      </Flex>
      <Flex spacing="lg" marginTop="auto">
        <SkeletonBox borderRadius="sm" height="32px" width="100px" />
        <SkeletonBox borderRadius="sm" height="32px" width="32px" />
      </Flex>
    </Card>
  </Skeleton>
);

const SimTileEmpty = () => (
  <Card variant="subtle" colorScheme="neutralStrong" flex="1" />
);

export { SimTileSkeleton, SimTileEmpty };
